import { useFetch } from "@/lib/axios.config";
import { useQuery } from "@tanstack/react-query";

export interface UsernameCheckPayload {
  username: string;
}

export interface UsernameCheckResponse {
  username_available: boolean;
  phone_available: boolean;
}

export const checkUsernameAvailability = async (
  data: UsernameCheckPayload
): Promise<UsernameCheckResponse> => {
  const response = await useFetch.post<UsernameCheckResponse>(
    "/users/CheckAccount",
    data
  );
  return response.data;
};

export const useUsernameAvailability = (username: string) => {
  return useQuery<UsernameCheckResponse, Error, UsernameCheckResponse>({
    enabled: !!username && username.length > 0,
    queryKey: ["username-availability", username],
    queryFn: () => checkUsernameAvailability({ username }),
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
